import { render, staticRenderFns } from "./ModernSelect.vue?vue&type=template&id=56dbd242&scoped=true&"
import script from "./ModernSelect.vue?vue&type=script&lang=js&"
export * from "./ModernSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dbd242",
  null
  
)

export default component.exports